import { useQuery } from "react-query";
import { fetchUserCollections } from "./api";

export function useCollections(options = {}) {
  return useQuery(["fetchUserCollections"], () => fetchUserCollections(), {
    staleTime: 60000 * 60,
    ...options,
  });
}
